import React, {useEffect} from 'react'
import {Top} from "pages/home/Top"
import {Outlet} from "react-router-dom"
import {setDefaultLocale} from "react-datepicker"
import 'dayjs/locale/ko'

import "echarts/theme/shine"
import "echarts/theme/london"
import 'react-loading-skeleton/dist/skeleton.css'
import "@fortawesome/fontawesome-free/css/all.min.css"
import "react-vertical-timeline-component/style.min.css"
import "css/bulma.min.css"
import "css/style.css"
// import "leaflet/dist/leaflet.css"
import "react-datepicker/dist/react-datepicker.css"

import {useFindEnvironment} from "hooks/queries/env.query"
import {useRootStore} from "store/useRootStore"
import dayjs from "dayjs";
import {ko} from "date-fns/locale"

dayjs.locale('ko')
setDefaultLocale('ko')

function App() {
    const {envStore} = useRootStore()
    const {data: result} = useFindEnvironment()

    useEffect(() => {
        if (result && result.body) {
            envStore.setEnv(result.body)
        }
    }, [envStore, result])
    return (
        <div className="wrapper">
            {/*<p>API_URL : {window._env_.API_URL}</p>*/}
            <Top/>
            <Outlet/>
        </div>
    );
}

export default App;
